/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Table from '../../components/common/Table';
import LevelDropdown from '../../components/common/LevelDropdown';
import axios from 'axios';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loading from '../../components/common/Loading';
import UserOrderModal from '../../components/user/UserOrderModal';
import UserDetailModal from '../../components/user/UserDetailModal';

const TrueButton = styled.button`
  display: inline-block;
  width: 60px;
  height: 35px;
  background: #eeeeee;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #164db5;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const FalseButton = styled.button`
  display: inline-block;
  width: 60px;
  height: 35px;
  background: #eeeeee;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #db3a34;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 28px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const OrderButton = styled.button`
  display: inline-block;
  width: 70px;
  height: 35px;
  background: #f0f4ff;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #164db5;
  font-size: 13px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const Toolbar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 12px;
  flex-wrap: wrap;
`;

const ToolGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SearchInput = styled.input`
  padding: 7px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  width: 240px;
  outline: none;
  transition: border-color 0.15s;
  &:focus { border-color: #007aff; }
`;

const Btn = styled.button`
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  outline: none;
  white-space: nowrap;
  background: ${({ $variant }) => ($variant === 'primary' ? '#007aff' : '#f3f4f6')};
  color: ${({ $variant }) => ($variant === 'primary' ? '#fff' : '#374151')};
  &:hover {
    background: ${({ $variant }) => ($variant === 'primary' ? '#0066d6' : '#e5e7eb')};
  }
`;

const TotalText = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
`;

const levelLabel = (level) => {
  const map = { vip: 'VIP', school: 'School', level1: 'Level 1', level2: 'Level 2', level3: 'Level 3', shoppingmall: 'Shopping Mall' };
  return map[level] || level || '-';
};

const UserListPage = () => {
  const [users, setUsers] = useState();
  const [rawUsers, setRawUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [detailUserId, setDetailUserId] = useState(null);
  const [sortDesc, setSortDesc] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const buildUserRows = (data) => {
    return data.map((r) => {
      const userId = r._id;
      const companyName = typeof r.company_name === 'string' ? r.company_name : r._company_name;
      const managerName = typeof r.manager_name === 'string' ? r.manager_name : r._manager_name;
      const userEmail = typeof r.user_email === 'string' ? r.user_email : r._user_email;
      const orderCount = r._order_count != null ? r._order_count : (r.order_count || 0);
      const hasMemo = r._has_memo || r.has_memo || false;

      const row = { _id: userId };
      row.user_email = userEmail;
      row.manager_name = managerName;
      row.manager_contact = r.manager_contact || r._manager_contact;
      row.company_name = (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          {companyName}
          {hasMemo && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" title="메모 있음">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          )}
        </span>
      );
      if (r.approval === true || r._approval === true) {
        row.level = (
          <LevelDropdown
            user={{ _id: userId }}
            level={r._level || r.level}
            handleLevel={_handleLevel}
            approved={true}
          />
        );
        row.approval = (
          <TrueButton onClick={(e) => { e.stopPropagation(); _handleDelete({ _id: userId }); }}>승인</TrueButton>
        );
      } else {
        row.level = <LevelDropdown user={{ _id: userId }} level={'설정'} approved={false} />;
        row.approval = (
          <FalseButton onClick={(e) => { e.stopPropagation(); _handleApprove({ _id: userId }); }}>대기</FalseButton>
        );
      }
      row.order_count = orderCount;
      row.orders = (
        <OrderButton onClick={(e) => { e.stopPropagation(); setSelectedUser({
          _id: userId,
          company_name: companyName,
          manager_name: managerName,
          user_email: userEmail,
        }); }}>
          주문내역
        </OrderButton>
      );
      row.reset = (
        <FalseButton onClick={(e) => { e.stopPropagation(); _handleReset({ _id: userId }); }}>리셋</FalseButton>
      );
      return row;
    });
  };

  const getUsers = async (query) => {
    try {
      setIsLoading(true);
      const q = query !== undefined ? query : searchQuery;
      const params = q ? `?search=${encodeURIComponent(q)}` : '';
      let res = await axios.get(`/admin/users/userlist${params}`);
      const raw = res.data.map((r) => ({
        _id: r._id,
        _user_email: r.user_email,
        _manager_name: r.manager_name,
        _manager_contact: r.manager_contact,
        _company_name: r.company_name,
        _level: r.level,
        _approval: r.approval,
        _order_count: r.order_count || 0,
        _has_memo: r.has_memo || false,
      }));
      raw.reverse();
      setRawUsers(raw);
      setUsers(buildUserRows(raw));
      setIsLoading(false);
    } catch (e) {
      console.log(e, 'getUsers');
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(searchInput);
    getUsers(searchInput);
  };

  const handleSearchReset = () => {
    setSearchInput('');
    setSearchQuery('');
    getUsers('');
  };

  const _handleApprove = async (user) => {
    const result = await swal.fire({
      text: '가입을 승인하시겠습니까?',
      icon: 'warning', iconColor: '#d33',
      showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#a8a8a8',
      confirmButtonText: '확인', cancelButtonText: '취소',
    });
    if (result.isConfirmed) {
      try {
        const res = await axios.patch(`/admin/users/update/${user._id}`);
        if (res.status === 200) {
          swal.fire({ text: '승인 완료', icon: 'success', showConfirmButton: false, timer: 1000 });
          getUsers();
        }
      } catch { swal.fire({ text: '오류 발생', icon: 'error', showConfirmButton: false, timer: 1000 }); }
    }
  };

  const _handleDelete = async (user) => {
    const result = await swal.fire({
      text: '승인을 취소하시겠습니까?',
      icon: 'warning', iconColor: '#d33',
      showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#a8a8a8',
      confirmButtonText: '확인', cancelButtonText: '취소',
    });
    if (result.isConfirmed) {
      try {
        const res = await axios.patch(`/admin/users/delete/${user._id}`);
        if (res.status === 200) {
          swal.fire({ text: '승인 취소 완료', icon: 'success', showConfirmButton: false, timer: 1000 });
          getUsers();
        }
      } catch { swal.fire({ text: '오류 발생', icon: 'error', showConfirmButton: false, timer: 1000 }); }
    }
  };

  const _handleReset = async (user) => {
    const result = await swal.fire({
      text: '비밀번호를 [000000]으로 리셋하시겠습니까?',
      icon: 'warning', iconColor: '#d33',
      showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#a8a8a8',
      confirmButtonText: '확인', cancelButtonText: '취소',
    });
    if (result.isConfirmed) {
      try {
        const res = await axios.patch(`/admin/users/password/${user._id}`);
        if (res.status === 200) {
          swal.fire({ text: '리셋 완료', icon: 'success', showConfirmButton: false, timer: 1000 });
          getUsers();
        }
      } catch { swal.fire({ text: '오류 발생', icon: 'error', showConfirmButton: false, timer: 1000 }); }
    }
  };

  const _handleLevel = async ({ level, user }) => {
    const result = await swal.fire({
      text: '등급을 변경하시겠습니까?',
      icon: 'warning', iconColor: '#d33',
      showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#a8a8a8',
      confirmButtonText: '확인', cancelButtonText: '취소',
    });
    if (result.isConfirmed) {
      try {
        const res = await axios.patch(`/admin/users/update/${user._id}/${level}`);
        if (res.status === 200) {
          swal.fire({ text: '등급 변경 완료', icon: 'success', showConfirmButton: false, timer: 1000 });
          getUsers();
        }
      } catch { swal.fire({ text: '오류 발생', icon: 'error', showConfirmButton: false, timer: 1000 }); }
    }
  };

  const handleSortByOrderCount = () => {
    const next = !sortDesc;
    setSortDesc(next);
    const sorted = [...rawUsers].sort((a, b) =>
      next ? b._order_count - a._order_count : a._order_count - b._order_count
    );
    setUsers(buildUserRows(sorted));
  };

  const handleExcelDownload = () => {
    if (!rawUsers || rawUsers.length === 0) return;
    const rows = rawUsers.map((r) => ({
      '이메일': r._user_email,
      '담당자': r._manager_name,
      '연락처': r._manager_contact,
      '회사명': r._company_name,
      '등급': levelLabel(r._level),
      '승인': r._approval ? '승인' : '대기',
      '주문횟수': r._order_count,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    ws['!cols'] = [
      { wch: 28 }, { wch: 12 }, { wch: 16 }, { wch: 20 },
      { wch: 12 }, { wch: 8 }, { wch: 10 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '회원목록');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), '회원목록.xlsx');
  };

  const handleRowClick = (index) => {
    if (users && users[index]) {
      setDetailUserId(users[index]._id);
    }
  };

  const titles = [
    '이메일',
    '담당자 이름',
    '담당자 연락처',
    '회사명',
    '등급',
    '승인 여부',
    <span style={{ cursor: 'pointer', userSelect: 'none' }} onClick={handleSortByOrderCount}>
      주문횟수 {sortDesc ? '\u25BC' : '\u25B2'}
    </span>,
    '주문내역',
    '비밀번호 리셋',
  ];

  useEffect(() => {
    getUsers('');
  }, []);

  return (
    <Container>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0 }}>회원 목록</h2>
      </div>

      <Toolbar>
        <ToolGroup>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 6 }}>
            <SearchInput
              placeholder="이메일, 회사명, 담당자, 연락처 검색"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <Btn $variant="primary" type="submit">검색</Btn>
          </form>
          {searchQuery && <Btn onClick={handleSearchReset}>초기화</Btn>}
        </ToolGroup>
        <ToolGroup>
          <Btn onClick={handleExcelDownload} style={{ background: '#1d6f42', color: '#fff' }}>
            엑셀 다운로드
          </Btn>
          <TotalText>총 {rawUsers.length}명</TotalText>
        </ToolGroup>
      </Toolbar>

      {users && users.length > 0 ? (
        <Table
          titles={titles}
          data={users}
          onRowClick={handleRowClick}
        />
      ) : !isLoading && (
        <div style={{ color: '#86868b', fontSize: 15, padding: '80px 0', textAlign: 'center', width: '100%' }}>
          {searchQuery ? '검색 결과가 없습니다.' : '회원이 없습니다.'}
        </div>
      )}
      {isLoading && <Loading />}

      {selectedUser && (
        <UserOrderModal
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}
      {detailUserId && (
        <UserDetailModal
          userId={detailUserId}
          onClose={() => { setDetailUserId(null); getUsers(); }}
        />
      )}
    </Container>
  );
};

export default UserListPage;
